import React from 'react';

import PropTypes from 'prop-types';

import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';

import ConnectedTopNavigationOptionalUser from './ConnectedTopNavigationOptionalUser';
import NavigationLayout from './NavigationLayout';

const EntitlementsErrorPage = React.forwardRef(({ onLogout }, ref) => {
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));

  return (
    <NavigationLayout
      ref={ref}
      renderSideNavigation={() => null}
      renderTopNavigation={() => (
        <ConnectedTopNavigationOptionalUser onLogout={onLogout} />
      )}
    >
      <div
        css={[
          {
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
        ]}
      >
        <EmptyState
          size={EmptyState.SIZES.LARGE}
          illustrationType={
            EmptyState.ILLUSTRATION_TYPES.BUILDING_CONSTRUCTION_GREY
          }
          title={T.translate('ERROR_PAGE_TITLE')}
          description={T.translate('ERROR_PAGE_DESCRIPTION')}
        >
          <div
            css={[
              {
                marginTop: 48,
                ...theme.typography.heading2,
              },
            ]}
          >
            <LinkButton onClick={() => window.location.reload()}>
              {T.translate('TRY_AGAIN')}
            </LinkButton>
          </div>
        </EmptyState>
      </div>
    </NavigationLayout>
  );
});

EntitlementsErrorPage.displayName = 'EntitlementsErrorPage';

EntitlementsErrorPage.propTypes = {
  /** callback called on logout */
  onLogout: PropTypes.func,
};

export default EntitlementsErrorPage;
